"use client";
import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import { useTracking } from "react-tracking";
import { Box } from "@mui/material";
import { AccordionItem } from "./AccordionItem/index.js";
const AccordionSection = ({
  content,
  icons,
  accordionContentEntries,
  isMultiAccordionOpen,
  bodyBackgroundColor,
  colorConfigHashMap
}) => {
  var _a, _b;
  const accordionItems = content ?? [];
  const { trackEvent } = useTracking();
  const [expandedIndexes, setExpandedIndexes] = useState([]);
  const pageType = typeof window !== "undefined" ? ((_a = window == null ? void 0 : window.digitalData) == null ? void 0 : _a.pageName) ?? "" : "";
  if (!content || !colorConfigHashMap) {
    return null;
  }
  const {
    accordionactiveTextBackgroundColor,
    accordiondefaultTextBackgroundColor,
    accordionhoverTextBackgroundColor,
    accordionactiveTextColor,
    accordiondefaultTextColor,
    accordionhoverTextColor,
    accordionactiveDividerColor,
    accordiondefaultDividerColor,
    accordionhoverDividerColor
  } = colorConfigHashMap;
  const pushAnalytics = (title, action) => {
    trackEvent({
      trackType: "navigation",
      component: {
        type: "ui",
        identifier: "Accordion Set",
        trackedData: [
          `${pageType} Accordion | ${title == null ? void 0 : title.trim()} | ${action}`
        ]
      }
    });
  };
  const onToggleAccordion = (accordionId, accordionTitle) => {
    const isCurrentlyExpanded = expandedIndexes.includes(accordionId);
    const accordionAction = isCurrentlyExpanded ? "Shrink" : "Expand";
    pushAnalytics(accordionTitle ?? "", accordionAction);
    if (isMultiAccordionOpen) {
      setExpandedIndexes(
        (prevIndexes) => prevIndexes.includes(accordionId) ? prevIndexes.filter((id) => id !== accordionId) : [...prevIndexes, accordionId]
      );
    } else {
      setExpandedIndexes(
        (prevIndexes) => prevIndexes.includes(accordionId) ? [] : [accordionId]
      );
    }
  };
  const getBaseContentByUid = (uid) => {
    const entry = accordionContentEntries.find(
      (contentEntry) => uid in contentEntry
    );
    return entry ? entry[uid] : void 0;
  };
  return /* @__PURE__ */ jsx(
    Box,
    {
      sx: {
        backgroundColor: ((_b = bodyBackgroundColor == null ? void 0 : bodyBackgroundColor.background_color) == null ? void 0 : _b.hex) || "#FFF"
      },
      children: accordionItems.map((accordionItem) => {
        const accordionItemUID = accordionItem._metadata.uid;
        const accordionDetailUID = accordionItem.ad_ref[0].uid;
        const isExpanded = expandedIndexes.includes(accordionDetailUID);
        return /* @__PURE__ */ jsx(
          AccordionItem,
          {
            activeTextBackgroundColor: accordionactiveTextBackgroundColor,
            activeTextColor: accordionactiveTextColor,
            activeDividerColor: accordionactiveDividerColor,
            defaultTextBackgroundColor: accordiondefaultTextBackgroundColor,
            defaultTextColor: accordiondefaultTextColor,
            defaultDividerColor: accordiondefaultDividerColor,
            hoverTextBackgroundColor: accordionhoverTextBackgroundColor,
            hoverTextColor: accordionhoverTextColor,
            hoverDividerColor: accordionhoverDividerColor,
            isActive: isExpanded,
            isExpanded,
            icons: icons[accordionItemUID],
            details: getBaseContentByUid(accordionDetailUID),
            onChange: () => {
              var _a2, _b2;
              return onToggleAccordion(
                accordionDetailUID,
                ((_b2 = (_a2 = accordionItem.accordion_title_group) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.markdown_text) || ""
              );
            },
            titles: accordionItem.accordion_title_group
          },
          accordionItemUID
        );
      })
    }
  );
};
export {
  AccordionSection
};
